export const DIALYSIS = 'Dialysis'
export const RESIDENCY = 'Residency'
export const HOUSEHOLDSIZE = 'HouseholdSize'
export const INCOMELEVEL = 'IncomeLevel'
export const INSURANCE = 'Insurance'
export const COVERAGE = 'Coverage'
export const RETURNING = 'Returning'
export const YES = 'Yes'
export const NO = 'No'
export const NEXT = 'Next'
export const NEXT2 = 'Next2'
export const DENIED = 'Denied'
export const DENIED1 = 'Denied1'
export const DENIED2 = 'Denied2'
export const DENIED3 = 'Denied3'
export const ELIGIBLE = 'Eligible'
export const ERROR = 'Error'
export const OTHER = 'Other'
export const ENROLLURL = '/how-to-apply.html'
export const FORMS_URL = '/resources-forms.html'
